// eslint-disable-next-line no-unused-vars
import React from 'react';
import { bool, func } from 'prop-types';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { useTranslation } from 'react-i18next';

import { NWButton } from 'Components/shared';

const StyledProductPriceRequest = styled.div`
  button {
    border-radius: 0;
  }
`;

const ProductPriceRequest = ({ loading, handlePriceRequest }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <StyledProductPriceRequest theme={ theme } className="productPriceRequest">
      <NWButton
        kind="danger"
        loading={ loading }
        onClick={ handlePriceRequest }
      >
        { t('product.requestOffer') }
      </NWButton>
    </StyledProductPriceRequest>
  );
};

ProductPriceRequest.propTypes = {
  loading: bool,
  handlePriceRequest: func,
};

export default ProductPriceRequest;
